import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";

const faqs = [
  {
    q: "Mikor érdemes villanyszerelőt hívni?",
    a: "Bármilyen 230V/400V hálózati munka, biztosítéktábla bővítés, FI relé csere, új áramkör kihúzása, falba szerelés esetén kötelező szakembert hívni. Lámpacsere konnektorba csatlakoztatva házilag elvégezhető — minden más esetben hívjon minket.",
  },
  {
    q: "Mennyi időbe telik egy átlagos hibajavítás?",
    a: "A diagnózist követően 1-3 óra a leggyakoribb. Egyszerű konnektor- vagy kapcsolócsere 30 perc, biztosítéktábla bővítés fél nap, teljes lakáshálózat 3-7 munkanap. Az AI hibadiagnosztikánk pontos becslést ad.",
  },
  {
    q: "Adnak garanciát a munkára?",
    a: "Igen. Minden szerelésünkre 24 hónap teljes körű garanciát vállalunk, írásban, számlán feltüntetve. Vészhelyzeti kiszállásnál is. A VargaVolt Kft. 10M Ft felelősségbiztosítással rendelkezik.",
  },
  {
    q: "Hol dolgoznak?",
    a: "Tápióbicske székhellyel az ország egész területén dolgozunk, kb. 200-300 km-es körzetben. Budapest, Pest megye, Heves, Nógrád, Jász-Nagykun-Szolnok, Bács-Kiskun, Fejér megyét rendszeresen ellátjuk. Ipari megbízásokra távolabbra is kiszállunk, előzetes egyeztetés után.",
  },
  {
    q: "Adnak előre árajánlatot?",
    a: "Igen. A kiszállás díja terhére előzetes felmérést végzünk, és írásos árajánlatot adunk. Ha elfogadja, a kiszállási díjat jóváírjuk a munkadíjból.",
  },
  {
    q: "Milyen fizetési módokat fogadnak el?",
    a: "Készpénz, bankkártya helyszínen (SumUp), átutalás. Cégeknek halasztott fizetés egyeztetés szerint.",
  },
];

export default function FAQ() {
  const [open, setOpen] = useState(0);

  return (
    <section data-testid="faq-section" className="border-b border-[#262626]">
      <div className="max-w-4xl mx-auto px-4 md:px-8 py-16 md:py-24">
        <div className="font-mono text-xs text-[#FFD700] uppercase tracking-[0.4em] mb-3">
          [ 06 / FAQ ]
        </div>
        <h2 className="font-heading uppercase text-4xl md:text-6xl leading-none mb-12">
          Gyakori <span className="text-[#FFD700]">kérdések.</span>
        </h2>

        <div className="border-t border-[#262626]">
          {faqs.map((f, i) => (
            <div
              key={i}
              data-testid={`faq-${i}`}
              className="border-b border-[#262626]"
            >
              <button
                onClick={() => setOpen(open === i ? -1 : i)}
                className="w-full flex items-center justify-between gap-4 py-5 text-left hover:bg-[#0A0A0A] px-2 transition-colors"
                data-testid={`faq-toggle-${i}`}
              >
                <span className="font-heading uppercase text-lg md:text-xl">{f.q}</span>
                <span className="shrink-0 w-8 h-8 border-2 border-[#FFD700] text-[#FFD700] flex items-center justify-center">
                  {open === i ? <Minus className="w-4 h-4" /> : <Plus className="w-4 h-4" />}
                </span>
              </button>
              {open === i && (
                <div data-testid={`faq-answer-${i}`} className="px-2 pb-6 text-[#A3A3A3] font-mono text-sm leading-relaxed">
                  {f.a}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
